export default __webpack_public_path__ + "static/media/page-comment.7b261b08.svg";